export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('input');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    DOMC.addType('input', {
        isComponent(el) {
            if (el.tagName === 'INPUT') {
                return { type: 'input' };
            }
        },
        extend: 'input',
        extendFn: ['updateTraits'],
        model: {
            defaults: {
                // ...MODEL.prototype.defaults,
                traits: MODEL.prototype.defaults.traits.concat([
                    {
                        type: 'number',
                        name: 'data-slg-control-max-length',
                        label: 'Max length'
                    },
                    {
                        type: 'select',
                        options: [
                            { id: null, name: 'Disabled' },
                            { id: 'number', name: 'Number' },
                            { id: 'text', name: 'Text' },
                        ],
                        name: 'data-slg-control-type',
                        label: 'Control type'
                    },
                    {
                        type: 'checkbox',
                        name: 'data-slg-follow-in-query',
                        label: 'Follow in query'
                    },
                    {
                        type: 'text',
                        name: 'data-slg-validate-pattern',
                        label: 'Validate pattern'
                    }
                ])
            },
            init() {
                // this.addControlMaxLength();
                // this.addControlType();
                // this.addFollowInQuery();
                // this.addValidatePattern();
                this.updateTrait('type', {
                    options: [
                        'text', 
                        'number',
                        "email",
                        "password",
                        "date"
                    ],
                });

            },
            updateTraits() {
                this.addControlMaxLength();
                this.addControlType();
                this.addFollowInQuery();
                this.addValidatePattern();
            },

            addMutedTrait() {
                if (!this.getTrait('muted')) {
                    this.addTrait({
                        type: 'checkbox',
                        name: 'muted',
                    })
                }
            },
            addControlMaxLength() {
                if (!this.getTrait('data-slg-control-max-length')) {
                    this.addTrait({
                        type: 'number',
                        name: 'data-slg-control-max-length',
                        label: 'Max length'
                    })
                }
            },
            addControlType() {
                if (!this.getTrait('data-slg-control-type')) {
                    this.addTrait({
                        type: 'select',
                        options: [
                            { id: null, name: 'Disabled' },
                            { id: 'number', name: 'Number' },
                            { id: 'text', name: 'Text' },
                        ],
                        name: 'data-slg-control-type',
                        label: 'Control type'
                    })
                }
            },
            addFollowInQuery() {
                if (!this.getTrait('data-slg-follow-in-query')) {
                    this.addTrait({
                        type: 'checkbox',
                        name: 'data-slg-follow-in-query',
                        label: 'Follow in query'
                    })
                }
            },

            addValidatePattern() {
                if (!this.getTrait('data-slg-validate-pattern')) {
                    this.addTrait({
                        type: 'text',
                        name: 'data-slg-validate-pattern',
                        label: 'Validate pattern'
                    })
                }
            }

        },
    });
}
